var _circle, _circle2, _line, _circle3, _circle4, _line2, _line3, _line4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "#9AACCF",
    stroke: "#9AACCF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.14474,
    cy: 4.2474,
    r: 4.14474,
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.14474,
    cy: 19.9054,
    r: 4.14474,
    stroke: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.91444,
    y1: 20.3658,
    x2: 3.91444,
    y2: 3.7869,
    fill: "none",
    strokeWidth: 1.38158
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8816,
    cy: 4.2474,
    r: 4.14474,
    stroke: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8816,
    cy: 19.9054,
    r: 4.14474,
    stroke: "none"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19.5723,
    y1: 20.3658,
    x2: 19.5723,
    y2: 3.7869,
    fill: "none",
    strokeWidth: 1.38158
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.60522,
    y1: 4.01722,
    x2: 18.421,
    y2: 4.01722,
    fill: "none",
    strokeWidth: 1.38158
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4.60522,
    y1: 19.6751,
    x2: 18.421,
    y2: 19.6751,
    fill: "none",
    strokeWidth: 1.38158
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoi);
export default __webpack_public_path__ + "static/media/poi.f1bca477.svg";
export { ForwardRef as ReactComponent };